/* @flow */
import React from 'react';
// $FlowIgnore
import { MdContentPaste } from 'react-icons/md';

export default function ClinicalIcon({
  style
}: Object): React.Element {
  return <MdContentPaste style={style} />;
}
